
import React from 'react';
import { AlertCircle, XCircle } from 'lucide-react';

interface ErrorDisplayProps {
  error: string | null;
  onDismiss: () => void;
}

export const ErrorDisplay: React.FC<ErrorDisplayProps> = ({ error, onDismiss }) => {
  if (!error) return null;
  
  return (
    <div className="bg-[#3f1a1a] rounded-lg p-4 mb-6 relative">
      <div className="flex items-start gap-2">
        <AlertCircle className="h-5 w-5 text-red-400 mt-0.5 flex-shrink-0" />
        <div className="text-[#CECFD2] pr-8">
          {error}
        </div>
        <button 
          onClick={onDismiss}
          className="absolute top-2 right-2 text-gray-400 hover:text-white"
          aria-label="Dismiss error"
        >
          <XCircle className="h-5 w-5" />
        </button>
      </div>
    </div>
  );
};
